import { connect, sendMessage, addMessageListener } from "./transport/js-bridge-message";

export const initConnection = () => {
  return connect();
};

// experiment. can be removed
export const requestDebug = (message) => {
  sendMessage('/js-console', message);
};

export const requestOnReady = () => {
  sendMessage('/editor/ready');
};

export const requestClose = () => {
  sendMessage('/ws/project/on-back-button');
};

export const requestNothingToSave = () => {
  sendMessage('/ws/project/nothing-to-save');
};

export const requestCancelSaveReason = (data) => {
  sendMessage('/ws/project/cancel-save-reason', data);
};

export const requestLoadProject = () => {
  sendMessage('/ws/project/load-project');
};

export const requestSaveProject = (data, dispatch, setSavedProjectName) => {
  sendMessage('/ws/project/save-project', data, (clb => {
    dispatch(setSavedProjectName(clb));
  }));
};

export const requestOpenPrintDialog = (data) => {
  const request_id = Math.floor(Math.random() * 10000) % 10000;
  sendMessage('/ws/print/open-print-dialog', { ...data, request_id});
};

export const requestRenderedImage = (data) => {
  sendMessage('/ws/print/rendered-image', data);
};

export const onRequestSaveProjectIfChanged = (clb) => {
  addMessageListener('/ws/project/request-save-project-if-changed', clb);
};

export const onRequestOpenProject = (clb) => {
  addMessageListener('/ws/project/open-project', clb);
};

export const onRequestOpenPrintDialog = (clb) => {
  addMessageListener('/ws/print/open-print-dialog', clb);
};

export const onUploadImage = (clb) => {
  sendMessage('/ws/upload-image', null, clb);
};

export const onRequestOnReady = (clb) => {
  addMessageListener('/editor/ready', clb);
};

export const onRequestAutoSaveProject = (clb) => {
  addMessageListener('/ws/project/auto-save', clb);
}

export const sendAutoSavedProject = (payload) => {
  sendMessage('/ws/project/auto-save', payload);
}